export default "__VITE_ASSET__CvJ$pNM7__"